import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'app-root',
	template: `<router-outlet></router-outlet>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [RouterModule],
	host: {
		class: 'dis-block w-100 h-100',
	},
})
export class RootPageComponent {}
